// import React, { useMemo, useState } from "react";
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import interactionPlugin from "@fullcalendar/interaction";

// const CRMAttendanceCalendar = ({ attendanceByUserId }) => {
//     const [attendancePopup, setAttendancePopup] = useState({
//         show: false,
//         date: null,
//         checkIn: null,
//         checkOut: null,
//     });

//     // ================= PRESENT SET =================
//     const presentDateSet = useMemo(() => {
//         const data = attendanceByUserId?.userAttendance ?? [];
//         const present = new Set();

//         data.forEach((entry) => {
//             if (entry?.checkIn && entry?.checkOut) {
//                 const d = new Date(entry.checkIn);
//                 const key = d.toISOString().split("T")[0];
//                 present.add(key);
//             }
//         });

//         return present;
//     }, [attendanceByUserId]);

//     // ================= DATE CLICK =================
//     const handleDateClick = (info) => {
//         const clickedDate = info.date;
//         const today = new Date();
//         if (clickedDate > today) return;

//         const dateKey = clickedDate.toISOString().split("T")[0];

//         const record = (attendanceByUserId?.userAttendance || []).find((r) =>
//             r.checkIn && r.checkIn.startsWith(dateKey)
//         );

//         const formatTime = (dt) => {
//             if (!dt) return "00:00";
//             const d = new Date(dt);
//             return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//         };

//         setAttendancePopup({
//             show: true,
//             date: clickedDate,
//             checkIn: record?.checkIn ? formatTime(record.checkIn) : "00:00",
//             checkOut: record?.checkOut ? formatTime(record.checkOut) : "00:00",
//         });
//     };

//     // ================= CELL CONTENT =================
//     const renderDayCell = (arg) => {
//         const cellDate = arg.date;
//         const today = new Date();

//         const key = cellDate.toISOString().split("T")[0];
//         const isPresent = presentDateSet.has(key);
//         const isFuture = cellDate > today;

//         return (
//             <div className="crm-attendance-cell">
//                 <div className="crm-date">{arg.dayNumberText}</div>

//                 {!isFuture && (
//                     <div className={isPresent ? "crm-present" : "crm-absent"}>
//                         {isPresent ? "P" : "A"}
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     return (
//         <>
//             <div className="crm-attendance-calendar">
//                 <FullCalendar
//                     plugins={[dayGridPlugin, interactionPlugin]}
//                     initialView="dayGridMonth"
//                     headerToolbar={{
//                         left: "",
//                         center: "prev,title,next",
//                         right: "",
//                     }}
//                     events={[]}
//                     dayCellContent={renderDayCell}
//                     dateClick={handleDateClick}
//                     height="auto"
//                 />
//             </div>

//             {/* POPUP */}
//             {attendancePopup.show && (
//                 <div className="attendance-popup-overlay">
//                     <div className="attendance-popup">
//                         <div className="popup-header">
//                             <b>{attendancePopup.date.toDateString()}</b>
//                             <span
//                                 className="popup-close"
//                                 onClick={() => setAttendancePopup({ show: false })}
//                             >
//                                 ✕
//                             </span>
//                         </div>

//                         <div className="popup-row">
//                             <span>Check-in</span>
//                             <span style={{ color: "green" }}>{attendancePopup.checkIn}</span>
//                         </div>

//                         <div className="popup-row">
//                             <span>Check-out</span>
//                             <span style={{ color: "red" }}>{attendancePopup.checkOut}</span>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default CRMAttendanceCalendar;

import React, { useMemo, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

const CRMAttendanceCalendar = ({ attendanceByUserId }) => {
  console.log('🚀 ~ CRMAttendanceCalendar ~ attendanceByUserId:', attendanceByUserId);
  const [attendancePopup, setAttendancePopup] = useState({
    show: false,
    date: null,
    checkIn: null,
    checkOut: null,
  });
  const [currentRange, setCurrentRange] = useState(null);
  // ================= PRESENT SET =================
  const presentDateSet = useMemo(() => {
    const data = attendanceByUserId?.userAttendance ?? [];
    const present = new Set();
    data.forEach((entry) => {
      if (entry?.checkIn && entry?.checkOut) {
        const d = new Date(entry.checkIn);
        const key = d.toISOString().split('T')[0];
        present.add(key);
      }
    });
    return present;
  }, [attendanceByUserId]);

  // ================= DATE CLICK =================
  const handleDateClick = (info) => {
    const clickedDate = info.date;
    const today = new Date();

    // Don't allow clicking future dates
    if (clickedDate > today) return;

    const dateKey = clickedDate.toISOString().split('T')[0];
    const record = (attendanceByUserId?.userAttendance || []).find(
      (r) => r.checkIn && r.checkIn.startsWith(dateKey)
    );

    const formatTime = (dt) => {
      if (!dt) return '00:00';
      const d = new Date(dt);
      return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    setAttendancePopup({
      show: true,
      date: clickedDate,
      checkIn: record?.checkIn ? formatTime(record.checkIn) : '00:00',
      checkOut: record?.checkOut ? formatTime(record.checkOut) : '00:00',
    });
  };

  // ================= CELL CONTENT =================
  // const renderDayCell = (arg) => {
  //     const cellDate = arg.date;
  //     const today = new Date();
  //     today.setHours(23, 59, 59, 999); // Set to end of today for accurate comparison

  //     const key = cellDate.toISOString().split("T")[0];
  //     const isPresent = presentDateSet.has(key);
  //     const isFuture = cellDate > today;

  //     return (
  //         <div className="day-cell-wrapper">
  //             <div className="day-number">{arg.dayNumberText}</div>
  //             {!isFuture && (
  //                 <div className={`attendance-badge ${isPresent ? "present" : "absent"}`}>
  //                     {isPresent ? "P" : "A"}
  //                 </div>
  //             )}
  //         </div>
  //     );
  // };

  // ================= CLOSE POPUP =================
  const closePopup = () => {
    setAttendancePopup({ show: false, date: null, checkIn: null, checkOut: null });
  };

  // ================= FORMAT DATE =================
  const formatPopupDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };
  // ================= ATTENDANCE EVENTS =================
  const attendanceEvents = useMemo(() => {
    const data = attendanceByUserId?.userAttendance ?? [];

    return data
      .map((record) => {
        const dateKey = record.checkIn?.split('T')[0];
        if (!dateKey) return null;

        // 🚨 If no checkOut → Absent
        if (!record.checkOut) {
          return {
            title: 'Absent',
            start: dateKey,
            allDay: true,
            extendedProps: {
              durationText: '00:00 Hrs',
            },
            classNames: ['attendance-absent-card'],
          };
        }

        // ✅ Convert decimal hours to HH:MM
        const totalMinutes = Math.round((record.duration || 0) * 60);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        const formattedDuration = `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')} Hrs`;

        const statusText = record.status || 'Present';

        return {
          title: statusText,
          start: dateKey,
          allDay: true,
          extendedProps: {
            durationText: formattedDuration,
          },
          classNames: [
            statusText === 'Half Day' ? 'attendance-halfday-card' : 'attendance-present-card',
          ],
        };
      })
      .filter(Boolean);
  }, [attendanceByUserId]);

  console.log('EVENTS:', attendanceEvents);

  const renderEventContent = (eventInfo) => {
    return (
      <div className="attendance-card">
        <div className="attendance-title mb-1">{eventInfo.event.title}</div>
        <div className="attendance-duration">{eventInfo.event.extendedProps.durationText}</div>
      </div>
    );
  };

  const handleEventClick = (clickInfo) => {
    const clickedDate = new Date(clickInfo.event.start);
    const dateKey = clickedDate.toISOString().split('T')[0];

    const record = (attendanceByUserId?.userAttendance || []).find(
      (r) => r.checkIn && r.checkIn.startsWith(dateKey)
    );

    const formatTime = (dt) => {
      if (!dt) return '00:00';
      const d = new Date(dt);
      return d.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    };

    setAttendancePopup({
      show: true,
      date: clickedDate,
      checkIn: record?.checkIn ? formatTime(record.checkIn) : '00:00',
      checkOut: record?.checkOut ? formatTime(record.checkOut) : '00:00',
    });
  };

  return (
    <div className="calendar-container">
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          left: '',
          center: 'prev title next',
          right: '',
        }}
        dateClick={handleDateClick}
        // dayCellContent={renderDayCell}
        height="100%"
        contentHeight="auto"
        editable={false}
        selectable={false}
        selectMirror={false}
        dayMaxEvents={false}
        weekends={true}
        fixedWeekCount={false}
        showNonCurrentDates={true}
        handleWindowResize={true}
        stickyHeaderDates={false}
        expandRows={true}
        events={attendanceEvents}
        eventClick={handleEventClick}
        eventContent={renderEventContent}
        datesSet={(arg) => {
          setCurrentRange({
            start: arg.start,
            end: arg.end,
          });
        }}
      />

      {/* ================= ATTENDANCE POPUP ================= */}
      {attendancePopup.show && (
        <div
          className="attendance-popup-overlay"
          onClick={closePopup}
          role="dialog"
          aria-modal="true"
          aria-labelledby="popup-title"
        >
          <div className="attendance-popup" onClick={(e) => e.stopPropagation()}>
            <div className="attendance-popup-header">
              <h3 className="attendance-popup-title" id="popup-title">
                {formatPopupDate(attendancePopup.date)}
              </h3>
              <button
                className="attendance-popup-close"
                onClick={closePopup}
                aria-label="Close popup"
              >
                ✕
              </button>
            </div>

            <div className="attendance-popup-content">
              <div className="attendance-time-item">
                <span className="attendance-time-label">Check-in</span>
                <span className="attendance-time-value">{attendancePopup.checkIn}</span>
              </div>
              <div className="attendance-time-item">
                <span className="attendance-time-label">Check-out</span>
                <span className="attendance-time-value">{attendancePopup.checkOut}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CRMAttendanceCalendar;
